<template>
  <time-ago v-show="withinLastWeek" :date="date" class="last-booked">
    Last booked
  </time-ago>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { olderThan, WEEK } from '~/utility/date/relative'

@Component
class LastBooked extends Vue {
  @Prop({ required: true })
  date: string

  get withinLastWeek() {
    return !olderThan(this.date, WEEK)
  }
}

export default toNative(LastBooked)
</script>

<style scoped>
.last-booked {
  border-radius: 2em;
  border: 1px solid #ccc;
  color: var(--colour-text-light);
  display: inline-block;
  font-size: var(--small);
  padding: 0.2em 0.65em;
  white-space: pre-wrap;
  text-align: center;
  max-width: 100%;
}
</style>
